import { Component, OnInit } from '@angular/core';
import { FirebaseService } from '../../../services/auth/firebase.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit{

  constructor(public firebaseService: FirebaseService,
    private router: Router){}

  passwordVisibility: string = 'password'
  errorMessage: string = '';
  emailSent: string = ''

  //Login Form Params
  user = {email:'', password: ''}
  
  //Spinner
  login_spinner: boolean = false

  ngOnInit(){
    setTimeout(() => {
      this.login_spinner = true
    }, 500)
  }

  changePasswordVisibility(){
    if(this.passwordVisibility === 'password'){
      this.passwordVisibility = 'text'
    }
    else{
      this.passwordVisibility = 'password'
    }
  }

  registerFirebaseUser(){
    const email = this.user.email
    const password = this.user.password
    this.firebaseService.register({email, password}).then(
      res => console.log(res)
    ).catch(
      error => console.error("Firebase error: " + error)
    )
  }

  logInFirebaseUser(){
    this.emailSent = ''
    console.log("usuario", this.user)
    const email = (this.user.email.includes('@')) ? this.user.email : this.user.email + '@taboasutilvigo.com';
    const password = this.user.password;
    console.log("email", email)
    console.log("password", password)
    this.firebaseService.login({email, password}).then((userCredential) => {
      const user = userCredential.user;
      user.getIdToken()
        .then((idToken) => {
          this.firebaseService.navVisibility = true;
          this.router.navigate(['/lead']);
        })
        .catch((error) => {
          console.error('Error al obtener el token de acceso:', error);
        });
    }).catch(
      error =>{
        console.error("Firebase error msg: " + error.message)
        this.errorMessage = this.firebaseService.manageFirebaseError(error.message)
      }
    )
  }
}
